<template>
  <div>
    <form @submit.prevent="resetOldPassword" v-if="!mailSent" ref="form">
      <p>Renseignez l'e-mail de votre compte :</p>
      <div class="auth-login">
        <label for="email" class="orange">Identifiant</label>
        <span class="user">
          <input
            type="email"
            name="email"
            id="email"
            v-model="email"
            required
            placeholder="Votre adresse email"
          />
        </span>
        <button type="submit" class="orange-background">
          Demander la rénitialisation
        </button>
      </div>
    </form>
    <div v-else>
      <p>
        Si cet utilisateur existe sur acta-editions.com, un e-mail vient de vous
        être envoyé.<br />
        Cliquez sur le lien présent dans le mail pour réinitialiser votre mot de
        passe (vérifiez dans vos spams).
      </p>
    </div>
  </div>
</template>

<script>
import Authent from "@/api/authent.js";

export default {
  name: "Forgot",
  data() {
    return {
      email: "",
      mailSent: false,
    };
  },
  methods: {
    async resetOldPassword() {
      return Authent.resetPassword(this.email).then((response) => {
        this.mailSent = true;
      });
    },
  },
};
</script>

<style>
</style>